var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.0406 103.8704c33.7397-12.4893 46.6133-25.953 44.8879-30.6822-1.1622-3.1826-14.9388-7.5811-32.2914-3.0664-13.5799 3.5313-30.414 9.6016-48.6516 16.244 0 0-65.1549-24.0308-67.9263-23.0206-3.3078 1.207-12.5786 4.5773-16.7714 6.106-3.5492 1.2874 47.543 32.8547 47.543 32.8547-27.9823 11.6488-61.7666 24.281-61.7666 24.281s-15.7166-9.2797-18.8724-8.1264a6267.921 6267.921 0 0 1-10.7191 3.8978c-2.4049.8762 14.9209 16.4407 14.9209 16.4407s6.4636 8.958 19.7843 5.0869c15.4751-4.5058 119.528-36.1803 129.8717-40.0066l-.009-.009z",
    fill: "#ea0319",
    fillOpacity: 0.996
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.7d89ba94640c783d7e26cb6050c20235.svg";
export { ForwardRef as ReactComponent };